const pms_exit_repay_loan = [
  {
    value: "selling",
    name: "Selling",
  },
  {
    value: "refinancing",
    name: "Refinancing",
  },
  {
    value: "other",
    name: "Other",
  },
];

export default pms_exit_repay_loan;



// WEBPACK FOOTER //
// ./src/constants/pms_exit_repay_loan.js